export default __webpack_public_path__ + "static/media/history.45730b34.svg";